module.exports = __webpack_public_path__ + "static/media/close.f7dfc275.svg";